// keys.ts — RQ cache keys for the sessions-list suite. Private.

const SESSIONS_LIST_QUERY_KEY = {
  Root: 'sessions-list',
  List: 'list',
} as const;

interface ListKeyParams {
  search?: string;
  archived?: boolean;
  includeSessionId?: string;
}

export const sessionsListKeys = {
  all: [SESSIONS_LIST_QUERY_KEY.Root] as const,
  list: (params?: ListKeyParams) =>
    [...sessionsListKeys.all, SESSIONS_LIST_QUERY_KEY.List, params ?? {}] as const,
};
